export default __webpack_public_path__ + "static/media/LoginBtn.eae14814.svg";